import React from 'react';
import { SearchableTimelineList } from '@periscopes/general/timeline';
export const ValidationRuleTimelineTab = ({ sonarObjectId }) => React.createElement(SearchableTimelineList, { sonarObjectId: sonarObjectId });
